import { Component, Type, ViewChild } from "@angular/core";

import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherDetailCommentComponent } from "src/app/backoffice/acc/acc-voucher-detail-comment/acc-voucher-detail-comment.component";
import { InvVoucherKind } from "../../models/inv-voucher-kind.model";
import { InvVoucherKindFormComponent } from "../inv-voucher-kind-form/inv-voucher-kind-form.component";
import { InvVoucherKindImportExportFormComponent } from "../inv-voucher-kind-import-export/inv-voucher-kind-import-export-form.component";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";

@Component({
  selector: "ngx-inv-voucher-kind-list",
  templateUrl: "./inv-voucher-kind-list.component.html",
  styleUrls: ["./inv-voucher-kind-list.component.scss"],
})
export class InvVoucherKindListComponent extends BaseListComponent {
  isAdd: boolean = true;
  filterInfo: NameValue[] = [];
  actions: EntityListAction[];
  @ViewChild("grid") grid: KGridComponent;
  constructor() {
    super();
    this.inputEditorform = InvVoucherKindFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.label = this.translate("ClientApp.BackOffice.INV.InvVoucherKind.InvVoucherKindList");
    this.apiName = "InvVoucherKind";
    this.areaName = "Inventory";
    this.filterInfo = [{ Name: "IsWarehouse", Value: true, Operator: "eq" }];
    this.FillData();
    this.setactions();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.filterInfo = undefined;
    this.actions = undefined;
  }
  async FillData() {
    const information = this.accountService.authService.currentInformation();
    if (information.SaleInventory && (      
      information.InventoryKind !== SoftWareLicenseKind.InventoryWeb &&
      information.InventoryKind !== SoftWareLicenseKind.InventoryAdvancedWeb &&
      information.InventoryKind !== SoftWareLicenseKind.InventoryToAdvancedWeb)) {
      this.isAdd = false;
    }
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: InvVoucherKind,
    onRowsSelected: InvVoucherKind[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (action.name === "AccVoucherDetailComment") {
      if (!onRowSelected || !onRowSelected.HasJournalVoucher) {
        this.sts.showDialog("هیچ نوع سندی انتخاب نشده یا با سیستم حسابداری مرتبط نیست", "خطا");
        return;
      }
      let accVoucherDetailComment: Type<any> = AccVoucherDetailCommentComponent;
      this.dialogService
        .open(
          accVoucherDetailComment,
          {
            VoucherKindTitle: onRowSelected.Title,
            InvVoucherKindId: onRowSelected.Id,
          },
          {
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {});
    }
    if (action.name === "ImportFromExcel" || action.name === "ImportExport") {
      var gridInfo = this.getGridInfo(this.grid.grid.columns.toArray());
      this.dialogService
        .open(
          action.Form_Component,
          {
            gridInfo: gridInfo,
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
    return;
  }
  setactions() {
    this.actions = [
      {
        name: "AccVoucherDetailComment",
        disabled: false,
        displayName: "قالب شرح سند حسابداری",
        iconName: "icon-format_list_numbered_rtl-o",
        apiName: "AccVoucherDetailComment",
        areaName: "Accounting",
        permission: Permission.managePermission,
      },
      {
        name: "ImportExport",
        disabled: false,
        displayName: "استخراج و دریافت",
        iconName: "icon-import_export-o",
        apiName: "InvVoucherKind/ImportExport",
        areaName: "Inventory",
        Form_Component: InvVoucherKindImportExportFormComponent,
        permission: Permission.samePermission,
      },
    ];
  }
  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
